import {TypeFNSSimpleDescMarche} from './TypeFNSSimpleDescMarche';
import {TypeOuiNonInformComplementaire} from './TypeOuiNonInformComplementaire';
import {TypeProcFNS} from './TypeProcFNS';
import {CommunicationFNSSimple} from './CommunicationFNSSimple';
import {TypeLotsFNSSimple} from './TypeLotsFNSSimple';
export class Initial {

	public lots: TypeLotsFNSSimple;

	public informComplementaire: TypeOuiNonInformComplementaire;

	public procedure: TypeProcFNS;

	public communication: CommunicationFNSSimple;

	public natureMarche: TypeFNSSimpleDescMarche;

	public isMarcheAlloti: boolean;

	constructor() {
		this.lots = new TypeLotsFNSSimple();
		this.informComplementaire = new TypeOuiNonInformComplementaire();
		this.procedure = new TypeProcFNS();
		this.communication = new CommunicationFNSSimple();
		this.natureMarche = new TypeFNSSimpleDescMarche();
		this.isMarcheAlloti = true;
	}
}
